import en_US from './en';
import ja_JP from './ja';
import ko_KR from './ko';

export default {
	en_US,
	ja_JP,
	ko_KR,
};
